import React from 'react';
import FeatureCard from './FeatureCard';

export default function FeatureSection({ eyebrow, title, subtitle, tools, dark = false }) {
  return (
    <section className={`py-24 ${dark ? 'bg-black text-white' : 'bg-white'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 fade-in">
          <div className={`text-sm font-bold tracking-[0.25em] uppercase mb-3 ${dark ? 'text-[#22c55e]' : 'text-neutral-500'}`}>
            {eyebrow}
          </div>
          <h2 className={`text-4xl md:text-5xl font-black leading-tight mb-4 ${dark ? 'text-white' : 'text-black'}`}>
            {title}
          </h2>
          <p className={`text-lg max-w-3xl mx-auto ${dark ? 'text-neutral-300' : 'text-neutral-600'}`}>
            {subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((t, i) => (
            <FeatureCard key={t.title} {...t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
